
export type SKUTransformer = (sku: string) => string;

export const availableSKUTransformers: { [name: string]: SKUTransformer } = {

    /*
    Examples:
    00451-B-S
    00451-S-F
    */
    'POSTERBUTIKEN': (sku: string) => {
        let skuSplit = sku.split('-');
        let name = skuSplit.shift();
        let size = skuSplit.shift().toLowerCase();
        let border;
        let greyscale;

        for (let part of skuSplit) {
            switch (part) {
                case 'B':
                    border = true;
                    break;
                case 'F':
                    border = false;
                    break;
                case 'S':
                    greyscale = true;
                    break;
                case 'C':
                    greyscale = false;
            }
        }

        let borderWidths = {
            '21x30': 20,
            '30x40': 23,
            '40x50': 30,
            '50x70': 40,
            '70x100': 60,
        };

        let result = `POSTER_${size}`;

        if (border) {
            result += `_B${borderWidths[size]}W`;
            if (greyscale) {
                result += '&GREYSCALE';
            }
        }
        else {
            if (greyscale) {
                result += '_GREYSCALE';
            }
        }

        result += `_${name}`;

        return result;
    }
};